import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import {
    FacebookShareButton,
    TwitterShareButton,
    FacebookIcon,
    TwitterIcon,
    LineShareButton,
    LineIcon
} from "react-share";
import { Link } from "@components/Link"
import Image from "gatsby-image/withIEPolyfill"
import { useGtm } from '@hooks/useGtm'

import { useURL } from "@hooks/useURL"

import css from "@css/components/blocks/GlobalFooter.module.styl"
// import LogoSVG from "@images/IndexHero__lbl__fcntrecruit2021.svg"
// import NewsSvg from "@images/GlobalFooter__lbl__news.svg"
// import CompanyButtonSvg from "@images/GlobalFooter__btn__company.svg"
// import BusinessButtonSvg from "@images/GlobalFooter__btn__business.svg"


export default function GlobalFooter()
{
    const gtm = useGtm()
    const q = useStaticQuery(graphql`
        query {
            site {
                siteMetadata {
                    local
                    title
                    desc
                    site_url
                    site_name
                    site_publisher
                    image
                    sns_twitter_id
                    google_site_verification
                    keywords
                    share_text
                    share_tag
                }
            }

            productBanner: file(relativePath: { eq: "GlobalFooter__img__product-banner@2x.jpg" }) {
                childImageSharp {
                    fluid(maxWidth: 887) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }

        }
    `)
    const { site_url, share_text, share_tag } = q.site.siteMetadata
    const urls = useURL()

    const menuData = [
        {
            label: '会社概要',
            link: urls.company
        },{
            label: 'プライバシーポリシー',
            link: urls.privacy
        }
    ]
    const iconSize = 76

    return pug`
        footer(className=${css.container})
            div(className=${css.inner})
                div(className=${css.banners})
                    Link(className=${css.item} to=${urls.product} onClick=${ ()=>{
                        if( typeof window._gaq !== "undefined"){
                            window._gaq.push(['_trackEvent','arrows5G F-51A_adobeLPページ','click', '製品情報はこちら_F-51A_adobeLPページ'])
                        }
                    }})
                        Image(fluid=${q.productBanner.childImageSharp.fluid} alt="arrows 5G 製品情報はこちら")
                div(className=${css.sns})
                    TwitterShareButton(className=${css.item} url=${site_url} title=${share_text} hashtags=${share_tag}
                            onClick=${ () => {
                                if( typeof window._gaq !== "undefined"){
                                    window._gaq.push(['_trackEvent','arrows5G F-51A_adobeLPページ','click', 'Twitter_F-51A_adobeLPページ'])
                                }
                            }}
                        )
                        TwitterIcon(iconFillColor="#ffffff" round size=${iconSize})
                    FacebookShareButton(className=${css.item} url=${site_url} quote=${share_text} hashtags=${share_tag}
                        onClick=${ () => {
                            if( typeof window._gaq !== "undefined"){
                                window._gaq.push(['_trackEvent','arrows5G F-51A_adobeLPページ','click', 'Facebook_F-51A_adobeLPページ'])
                            }
                        }})
                        FacebookIcon(iconFillColor="#ffffff" round size=${iconSize})
                    // LineShareButton(className=${css.item} url=${url} quote=${share_text})
                        LineIcon(iconFillColor="#ffffff" bgStyle=${{fill: bgColor }} round size=${iconSize})
                div(className=${css.menu})
                    for item, i in ${menuData}
                        Link(key=${i} className=${css.item} to=${item.link}
                            onClick=${ () => {
                                if( typeof window._gaq !== "undefined"){
                                    window._gaq.push(['_trackEvent','arrows5G F-51A_adobeLPページ','click', `${item.label}_F-51A_adobeLPページ`])
                                }
                            }})
                            =${item.label}

                p(className=${css.trademark})
                    |Adobe、Adobeロゴ、Adobe Photoshop Express、および Adobe Photoshop Expressロゴはそれぞれ、アメリカ合衆国およびその他の国々におけるAdobe（アドビ社）の登録商標または標章です。
                    br
                    |Android、Google Play、Google マップ、Google フォト、およびその他のマークは Google LLC の商標です。
                p(className=${css.trademark2})
                    span © 沖 上田 - stock.adobe.com
                    span © Peach100  - stock.adobe.com　空と女性
                    span © HML - stock.adobe.com
                    span © beeboys - stock.adobe.com
                    span © garage38 - stock.adobe.com
                    span © Jesus Barroso - stock.adobe.com
                    span © merla - stock.adobe.com
                    span © milatas - stock.adobe.com
                    span © paylessimages - stock.adobe.com
                    span © peach100 - stock.adobe.com
                    span © PR Image Factory - stock.adobe.com
                    span © Solovivola Liudmyra- stock.adobe.com
                    span © sunabesyou - stock.adobe.com
                    span © taka - stock.adobe.com
                    span © tarasan - stock.adobe.com
                    span © Chaay_tee - stock.adobe.com
                p(className=${css.copyright})
                    |Copyright 2020 FUJITSU CONNECTED TECHNOLOGIES LIMITED
    `
}
